/**
 * This enum is used to define the control type
 */
export enum ControlType {
  /**
   * The primary type
   */
  Primary = 'primary',

  /**
   * The danger type
   */
  Danger = 'danger',

  /**
   * The warning type
   */
  Warning = 'warning',

  /**
   * The caution type
   */
  Caution = 'caution',

  /**
   * The success type
   */
  Success = 'success',

  /**
   * The info type
   */
  Info = 'info',

  /**
   * The accent type
   */
  Accent = 'accent',

  /**
   * The white type
   */
  White = 'white',
}
